/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2010-2019纷析云（杭州）科技有限公司All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : 凭证</li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2019年08月01日</li>
 * <li>@author     : ____′↘夏悸</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
import Ajax from '../js/common/ajax';
import Qs from "qs";

export default {
  list(page, params) {
    return Ajax.post("/voucher/list", params, {params: page})
  },
  lastDate() {
    return Ajax.get("/voucher/lastDate")
  },
  load(id) {
    return Ajax.get(`/voucher/${id}`)
  },
  loadCode(params) {
    return Ajax.get(`/voucher/code`, params)
  },
  summary() {
    return Ajax.get(`/voucher/summary`)
  },
  delete(records) {
    return Ajax.post(`/voucher/delete`, records)
  },
  deleteSync(records) {
    return Ajax.post(`/voucher/deleteSync`, records)
  },
  deleteById(voucherIds) {
    return Ajax.post(`/voucher/deleteById`, voucherIds)
  },
  save(params = {}) {
    console.log(params)
    return Ajax.post(`/voucher`, params)
  },
  sortNo(params = {}) {
    return Ajax.post(`/voucher/sortNo`, params)
  },
  saveTpl(params = {}) {
    return Ajax.post(`/voucher/tpl`, params)
  },
  tpl() {
    return Ajax.get(`/voucher/tpl`)
  },
  changeLog(voucherId) {
    return Ajax.get(`/voucher/changelog/` + voucherId)
  },
  deleteTpl(tplId) {
    return Ajax.delete(`/voucher/tpl/` + tplId)
  },
  update(params = {}) {
    return Ajax.put(`/voucher`, params)
  },
  carryForwardMoney(params = {}) {
    return Ajax.post(`/voucher/carryForwardMoney`, Qs.stringify(params, {indices: false}))
  },
  finishingOffNo(params = {}) {
    return Ajax.get(`/voucher/finishingOffNo`, params)
  },
  newFinishingOffNo(params = {}) {
    return Ajax.get(`/voucher/newFinishingOffNo`, params)
  },
  batchFinishingOffNo(params = {}) {
    return Ajax.get(`/voucher/batchFinishingOffNo`, params)
  },
  beforeId(params = {}) {
    return Ajax.get(`/voucher/beforeId`, params)
  },
  nextId(params = {}) {
    return Ajax.get(`/voucher/nextId`, params)
  },
  audit(params = {}) {
    return Ajax.post(`/voucher/audit`, Qs.stringify(params, {indices: false}))
  },
  batchAllAudit(year, month) {
    return Ajax.get(`/voucher/batch/audit`, {year, month})
  },
  cancelAudit(params = {}) {
    return Ajax.post(`/voucher/cancelAudit`, Qs.stringify(params, {indices: false}))
  },
  import(params) {
    return Ajax.post(`/voucher/import`, params, {'Content-Type': 'multipart/form-data'})
  },
  download(params, pagination) {
    return Ajax.post(`/voucher/download`, params,{params: pagination,responseType: 'blob'})
  },
  print(params,idList,page) {
    return Ajax.post(`/pdf/voucher`, params,{params: {id:idList,...page}})
  },
  printInvoice(params,idList,page,type) {
    return Ajax.post(`/pdf/invoice`, params,{params: {id:idList,type:type,...page}})
  },
  loadBatch(voucherIds) {
    return Ajax.get(`/voucher/batch/load?id=` + voucherIds.join("&id="))
  },
  voucherMerge(voucherIds) {
    return Ajax.post(`/voucher/merge`, voucherIds)
  },
  voucherMergeWithOptions(options) {
    return Ajax.post(`/voucher/merge/options`, options)
  },
  batchCopy(formData, voucherIds) {
    return Ajax.post("/voucher/batchCopy", voucherIds, {params: formData})
  },
  batchCarryover(year, month) {
    return Ajax.get(`/voucher/batchCarryover`, {year, month})
  },
  batchComplete(params){
    return Ajax.get(`/voucher/batchComplete`,params)
  },
  moveVoucher(ids,number){
    return Ajax.post(`/voucher/moveVoucher`,{ids,number})
  },
  updateVoucherSummer(id,summerVal){
    return Ajax.get(`/voucher/updateVoucherSummer?id=`+id+"&summer="+summerVal)
  },
  batchUpdateVoucherSummer(ids,summerVal){
    return Ajax.post(`/voucher/batchUpdateVoucherSummer?summer=`+summerVal,ids)
  },
  batchUpdateVoucherCustom(ids,customVal){
    return Ajax.post(`/voucher/batchUpdateVoucherCustom?custom=`+customVal,ids)
  },
  batchUpdateVoucherSubject(payload) {
    return Ajax.post(`/voucher/batchUpdateVoucherSubject`, payload)
  },
  pdfToImages(pdfUrl, dpi, crop) {
    return Ajax.get(`/pdf/pdfToImages`, {pdfUrl, dpi: dpi || 300, crop: crop || false})
  },
  pdfToImagesBatch(pdfUrls, dpi, crop) {
    return Ajax.post(`/pdf/pdfToImages/batch?dpi=${dpi || 300}&crop=${crop || false}`, pdfUrls, {repeatable: true})
  },
  renderVoucherPdf(params) {
    return Ajax.post('/pdf/voucher/template', params, {
      responseType: 'blob',
      repeatable: true
    })
  },
  printTaskList(params) {
    return Ajax.get('/print-task/list', params)
  },
  printTaskDownload(taskId) {
    return Ajax.get(`/print-task/${taskId}/download`)
  }
}
